module.exports = __webpack_public_path__ + "img/figure.b9057979.jpg";